import { Axios } from "api/axios";
import { useHandleBack } from "helpers/functions/useHandleBack";
import { useEffect, useState } from "react";
import { Button, Card, Col, Container, Row, Spinner } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";

const ViewCustomerDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [customer, setCustomer] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  const handleBack = useHandleBack("/customer");

  const fetchCustomerDetails = async () => {
    try {
      setLoading(true);
      const response = await Axios.get(`/api/customers/view-details/${id}/`);
      setCustomer(response.data.data);
    } catch (error) {
      console.error("Failed to fetch customer details", error);
      setCustomer(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCustomerDetails();
  }, [id]);

  const displayValue = (val: any) => val || "-";

  return (
    <Container fluid className="page-content">
      <Card className="w-100" style={{ borderRadius: "12px" }}>
        <Card.Header className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2">
          <h5 className="mb-1">
            <span style={{ cursor: "pointer" }} onClick={handleBack}>
              ←
            </span>{" "}
            View Customer/Company Details
          </h5>
          <div className="text-muted small">
            <span
              onClick={handleBack}
              style={{
                fontSize: "0.9rem",
                color: "#6c757d",
                cursor: "pointer",
              }}
            >
              Customer/Company
            </span>{" "}
            &gt;{" "}
            <span className="text-muted" style={{ fontSize: "0.9rem" }}>
              View Customer/Company
            </span>
          </div>
        </Card.Header>

        {loading ? (
          <div className="text-center py-5">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : !customer ? (
          <div className="d-flex flex-column align-items-center gap-3 my-4">
            <h5 className="mb-0 fw-bold text-center">
              Customer/Company details not found
            </h5>
            <Button
              variant="outlined"
              className="btn btn-secondary"
              onClick={handleBack}
            >
              Back
            </Button>
          </div>
        ) : (
          <Card.Body>
            {/* Customer Details */}
            <div className="mb-4">
              <h6 className="fw-bold mb-3">Customer/Company Details</h6>
              <Row
                className="g-3 p-3 rounded"
                style={{ backgroundColor: "#f5f9ff" }}
              >
                <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                  <p>
                    <strong>Customer/Company Name :</strong>{" "}
                    {displayValue(customer.customer_name)}
                  </p>
                </Col>
                <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                  <p>
                    <strong>Phone Number :</strong>{" "}
                    {displayValue(customer.mobile_no)}
                  </p>
                </Col>
                <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                  <p>
                    <strong>Email :</strong> {displayValue(customer.email)}
                  </p>
                </Col>
                <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                  <p>
                    <strong>GSTIN :</strong> {displayValue(customer.gstin)}
                  </p>
                </Col>
                <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                  <p>
                    <strong>PAN Number :</strong>{" "}
                    {displayValue(customer.pan_number)}
                  </p>
                </Col>
                <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                  <p>
                    <strong>Contact Person Name :</strong>{" "}
                    {displayValue(customer.contact_person_name)}
                  </p>
                </Col>
                <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                  <p>
                    <strong>Contact Person Mobile :</strong>{" "}
                    {displayValue(customer.contact_person_mobile_no)}
                  </p>
                </Col>
              </Row>
            </div>

            {/* Address Details */}
            <div>
              <h6 className="fw-bold mb-3">Address Details</h6>
              <Row
                className="g-3 p-3 rounded"
                style={{ backgroundColor: "#f5f9ff" }}
              >
                <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                  <p>
                    <strong>Address :</strong> {displayValue(customer.address)}
                  </p>
                </Col>
                <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                  <p>
                    <strong>Area :</strong> {displayValue(customer.area)}
                  </p>
                </Col>
                <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                  <p>
                    <strong>City :</strong> {displayValue(customer.city)}
                  </p>
                </Col>
                <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                  <p>
                    <strong>State :</strong> {displayValue(customer.state)}
                  </p>
                </Col>
                <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                  <p>
                    <strong>Country :</strong> {displayValue(customer.country)}
                  </p>
                </Col>
                <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                  <p>
                    <strong>Pin Code :</strong> {displayValue(customer.pincode)}
                  </p>
                </Col>
              </Row>
            </div>

            {/* Footer */}
            <div className="d-flex justify-content-center mt-4">
              <Button
                onClick={handleBack}
                // variant="light"
                // style={{
                //   border: "1px solid #ced4da",
                //   backgroundColor: "white",
                // }}
                className="btn btn-secondary"
              >
                Back
              </Button>
            </div>
          </Card.Body>
        )}
      </Card>
    </Container>
  );
};

export default ViewCustomerDetails;
